import { DeleteOutlined } from '@ant-design/icons';
import { Button, Popover, Typography, Space, Flex, Divider } from 'zui/Antd';
import { useEffect, useRef } from 'react';
import { theme } from 'antd';
import { devicesActions } from 'reduxStore/devices/slice';
import { useSelector, useDispatch } from 'react-redux';
import { selectDevicesByDeviceID } from 'reduxStore/devices/selectors';

const { Text } = Typography;

function DeleteDevicePopover({ visible, setVisible, selectedDevice, clickPosition = { x: 0, y: 0 } }) {
	const {
		token: { colorText, fontSizeLG, paddingXXS, padding, colorErrorText, fontWeightStrong }
	} = theme.useToken();
	const dispatch = useDispatch();
	const triggerRef = useRef(null);
	const { location } = useSelector((state) => selectDevicesByDeviceID(state, selectedDevice?.uID));
	const locationID = location && location.length > 0 ? location[0].locationID : null;

	const handleDelete = () => {
		if (locationID) {
			dispatch(devicesActions.deleteDeviceLocation({ deviceID: selectedDevice?.uID, locationID }));
		}
		setVisible(false);
	};

	useEffect(() => {
		if (triggerRef.current && clickPosition.x && clickPosition.y) {
			triggerRef.current.style.left = `${clickPosition.x}px`;
			triggerRef.current.style.top = `${clickPosition.y}px`;
		}
	}, [clickPosition]);

	const content = (
		<Flex vertical style={{ minWidth: 240 }}>
			<Space direction='vertical' style={{ width: '100%' }}>
				<Text strong style={{ color: colorText, fontSize: fontSizeLG }}>
					{selectedDevice?.name || 'Device'}
				</Text>
				<Divider style={{ margin: 0 }} />

				<Button
					type='text'
					danger
					icon={<DeleteOutlined />}
					onClick={handleDelete}
					block
					style={{
						textAlign: 'left',
						justifyContent: 'flex-start',
						padding: `${paddingXXS}px ${padding}px`,
						color: colorErrorText,
						fontWeight: fontWeightStrong
					}}
				>
					Remove Device
				</Button>
			</Space>
		</Flex>
	);

	return (
		<Popover
			content={content}
			title={null}
			trigger='click'
			open={visible}
			onOpenChange={setVisible}
			placement='bottomLeft'
		>
			<div
				ref={triggerRef}
				style={{
					position: 'fixed',
					width: '1px',
					height: '1px',
					left: clickPosition.x,
					top: clickPosition.y,
					pointerEvents: 'none',
					zIndex: 999
				}}
			/>
		</Popover>
	);
}

export default DeleteDevicePopover;
